import { cardList } from "./CardList";

function AboutCarts() {
  return (
    <>
      {cardList.map((card, id) => (
        <div
          key={id}
          className="group flex flex-col cursor-pointer bg-white justify-center py-8 px-6 sm:px-8 text-center items-center rounded-tl-[35px] rounded-br-[35px] shadow-2xl min-h-[280px] sm:min-h-[320px] w-full card-item-div transition-all duration-300 hover:-translate-y-2"
        >
          <img
            src={card.img}
            alt={`highlight_${card.title}`}
            className="w-[60px] sm:w-[75px] mb-4 transition-transform duration-300 group-hover:scale-110"
          />
          <p className="text-[20px] sm:text-[24px] font-bold uppercase mb-4 sm:mb-6 text-black group-hover:text-white transition-colors duration-200">
            {card.title}
          </p>
          <p className="text-[14px] sm:text-[15px] font-medium leading-relaxed w-full text-black group-hover:text-white transition-colors duration-200">
            {card.description}
          </p>
        </div>
      ))}
    </>
  );
}

export default AboutCarts;
